import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

import { Employee } from '../models/Employees';
import { LoaderService } from './loader.service';
import { TranslateService } from '../services/translate.service';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  loggedInEmployee: Employee = new Employee;

  constructor(private alertController: AlertController, private loader: LoaderService, public trans: TranslateService) {
  }
  async showAlertSingleButton(header: string, message: string, okButton?: string): Promise<void> {
    let resolveFunction: () => void;
    let rejectFunction: () => void;
    const promise = new Promise<void>((resolve, reject) => {
      resolveFunction = resolve;
      rejectFunction = reject;
    })

    let returnValue: string = "Not Set";
    if (okButton == null) {
      okButton = "Ok";
    }
    let alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: okButton,
          handler: () => { //takes the data
            resolveFunction();
            return true;
          }
        }
      ]
    });

    await alert.present();
    return promise;
  }
  async showAlert(header: string, message: string, okButton?: string, cancelButton?: string): Promise<void> {
    let resolveFunction: () => void;
    let rejectFunction: () => void;
    const promise = new Promise<void>((resolve, reject) => {
      resolveFunction = resolve;
      rejectFunction = reject;
    })

    let returnValue: string = "Not Set";
    if (okButton == null) {
      okButton = this.trans.translate("Ok");
    }
    if (cancelButton == null) {
      cancelButton = this.trans.translate("Cancel");
    }
    let alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: cancelButton,
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
            this.loader.hideForce();
            rejectFunction();
            return true;
          }
        }, {
          text: okButton,
          handler: () => { //takes the data
            resolveFunction();
            return true;
          }
        }
      ]
    });

    await alert.present();
    return promise;
  }
  async show3ButtonAlert(header: string, message: string, button1: string, button2: string, button3: string): Promise<number> {
    let resolveFunction: (number) => number;
    let rejectFunction: (number) => number;
    const promise = new Promise<number>((resolve: any, reject: any) => {
      resolveFunction = resolve;
      rejectFunction = reject;
    })

    let alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: button1,
          handler: () => {
            this.loader.hideForce();
            resolveFunction(1);
            return true;
          }
        }, {
          text: button2,
          handler: () => { //takes the data
            resolveFunction(2);
            return true;
          }
        }, {
          text: button3,
          handler: () => { //takes the data
            resolveFunction(3);
            return true;
          }
        }
      ]
    });

    await alert.present();
    return promise;
  }


  async showTextAlert(header: string, message: string, name: string, okButton?: string, cancelButton?: string, value?: string): Promise<string> {
    let resolveFunction: (confirm: string) => void;
    const promise = new Promise<string>(resolve => {
      resolveFunction = resolve;
    });

    let returnValue: string = "Not Set";
    if (okButton == null) {
      okButton = this.trans.translate("Ok");
    }
    if (cancelButton == null) {
      cancelButton = this.trans.translate("Cancel");
    }
    let alert = await this.alertController.create({
      header: header,
      message: message,
      inputs: [
        {
          name: name,
          placeholder: name,
          type: 'text',
          value: value
        }],
      buttons: [
        {
          text: cancelButton,
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.loader.hideForce();
            console.log('Confirm Cancel');
            return true;
          }
        }, {
          text: okButton,
          handler: (alertData) => { //takes the data
            console.log(alertData[name]);
            resolveFunction(alertData[name])
            return true;
          }
        }
      ]
    });

    await alert.present();
    return promise;
  }

  async show2TextAlert(header: string, message: string, name: string, name2: string, okButton?: string, cancelButton?: string, value1?: string, value2?: string): Promise<string[]> {
    let resolveFunction: (confirm: string[]) => void;
    const promise = new Promise<string[]>(resolve => {
      resolveFunction = resolve;
    });

    let returnValue: string = "Not Set";
    if (okButton == null) {
      okButton = this.trans.translate("Ok");
    }
    if (cancelButton == null) {
      cancelButton = this.trans.translate("Cancel");
    }
    let alert = await this.alertController.create({
      header: header,
      message: message,
      inputs: [
        {
          name: name,
          placeholder: name,
          type: 'text',
          value: value1
        }, {
          name: name2,
          placeholder: name2,
          type: 'text',
          value: value2
        }],
      buttons: [
        {
          text: cancelButton,
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.loader.hideForce();
            console.log('Confirm Cancel');
            return true;
          }
        }, {
          text: okButton,
          handler: (alertData) => { //takes the data
            console.log(alertData[name]);
            resolveFunction([alertData[name], alertData[name2]])
            return true;
          }
        }
      ]
    });

    await alert.present();
    return promise;
  }

  async show3TextAlert(header: string, message: string, name: string, name2: string, name3: string, okButton?: string, cancelButton?: string, value1?: string, value2?: string, value3?: string): Promise<string[]> {
    let resolveFunction: (confirm: string[]) => void;
    const promise = new Promise<string[]>(resolve => {
      resolveFunction = resolve;
    });

    let returnValue: string = "Not Set";
    if (okButton == null) {
      okButton = this.trans.translate("Ok");
    }
    if (cancelButton == null) {
      cancelButton = this.trans.translate("Cancel");
    }
    let alert = await this.alertController.create({
      header: header,
      message: message,
      inputs: [
        {
          name: name,
          placeholder: name,
          type: 'text',
          value: value1
        }, {
          name: name2,
          placeholder: name2,
          type: 'text',
          value: value2
        },
        {
          name: name3,
          placeholder: name3,
          type: 'text',
          value: value3
        }
      ],
      buttons: [
        {
          text: "X",
          handler: () => {
            return true
          }
        },
        {
          text: cancelButton,
          role: 'cancel',
          handler: () => {
            this.loader.hideForce();
            console.log('Confirm Cancel');
            return true;
          }
        }, {
          text: okButton,
          handler: (alertData) => { //takes the data
            console.log(alertData[name]);
            resolveFunction([alertData[name], alertData[name2], alertData[name3]])
            return true;
          }
        }
      ]
    });

    await alert.present();
    return promise;
  }
}
